"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const String_1 = require("@pups/utility/build/String");
const ColorManager_1 = require("./ColorManager");
class ColorBase {
    /**
     * Crea un nuovo colore
     *
     * @param {string} name
     * @param {string} colorString
     * @param {Array<string>} tags
     * @param {string} [id]
     * @memberof Color
     */
    constructor(colorStringOrObject, name, tags, id, defaultFormat) {
        if (!name.length) {
            name = String_1.randomString(5);
        }
        this.id = id || String_1.randomString();
        this.ccName = String_1.toCamelCase(name);
        this.name = name;
        this.tags = tags;
        this.format = defaultFormat || 'hex';
        this.value = new ColorManager_1.default(colorStringOrObject);
    }
    /**
     * Ritorna l'id
     *
     * @returns {string}
     * @memberof Color
     */
    getId() {
        return this.id;
    }
    /**
     * Ritorna il nome
     *
     * @returns {string}
     * @memberof Color
     */
    getName() {
        return this.name;
    }
    /**
     * Ritorna il nome
     *
     * @returns {string}
     * @memberof Color
     */
    getCcName() {
        return this.ccName;
    }
    /**
     * Ritorna il valore del colore in base al formato passato come argomento.
     *
     * @param {ColorFormat} type
     * @returns {string}
     * @memberof Color
     */
    getValue(format = this.format) {
        return this.value['to' + format.toUpperCase()]();
    }
    /**
     * Ritorna il nome
     *
     * @returns {Array<string>}
     * @memberof Color
     */
    getTags() {
        return this.tags;
    }
    /**
     * Setta l'id
     *
     * @param {string} id
     * @memberof Color
     */
    setId(id) {
        this.id = id;
    }
    /**
     * Setta il nome
     *
     * @param {string} name
     * @memberof Color
     */
    setName(name) {
        this.name = name;
        this.ccName = String_1.toCamelCase(name);
    }
    /**
     * Setta l'esadecimale
     *
     * @param {string} hex
     * @memberof Color
     */
    setValue(colorString) {
        this.value = new ColorManager_1.default(colorString);
    }
    /**
     * Setta i tags
     *
     * @param {Array<string>} tag
     * @memberof Color
     */
    setTags(tags) {
        this.tags = tags;
    }
    /**
     *
     *
     * @param {Types.Palette.Format} [toFormat=this.format]
     * @returns
     * @memberof ColorBase
     */
    toString(toFormat = this.format) {
        return this.getValue(toFormat);
    }
}
exports.default = ColorBase;
//# sourceMappingURL=ColorBase.js.map